import { createApiClient } from "Network/ApiClient";

export const ActivitiesReqirePreApprovalsAxiosInstance = createApiClient(
  "ActivityPreApproved/",
);
